import React from 'react';
import { useField } from 'formik';
import { clsx } from 'clsx';

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  name: string;
  label: string;
  description?: string;
  containerClassName?: string;
}

export function Checkbox({
  name,
  label,
  description,
  containerClassName,
  className,
  disabled,
  ...props
}: CheckboxProps) {
  const [field, meta] = useField({ name, type: 'checkbox' });
  const hasError = meta.touched && meta.error;

  return (
    <div className={clsx('w-full', containerClassName)}>
      <div className="flex items-start">
        <div className="flex h-5 items-center">
          <input
            id={name}
            type="checkbox"
            {...field}
            {...props}
            disabled={disabled}
            checked={field.value}
            className={clsx(
              'h-5 w-5 rounded border transition-colors duration-200',
              'text-primary-600 focus:ring-primary-500',
              'focus:ring-2 focus:ring-offset-0',
              'cursor-pointer',
              hasError ? 'border-red-500' : 'border-gray-300 dark:border-dark-600',
              disabled && 'cursor-not-allowed opacity-50',
              'dark:bg-dark-800 dark:checked:bg-primary-600',
              className
            )}
          />
        </div>
        <div className="ml-3">
          <label
            htmlFor={name}
            className={clsx(
              'text-sm font-medium',
              disabled
                ? 'text-gray-400 dark:text-gray-600'
                : 'cursor-pointer text-gray-700 dark:text-gray-300'
            )}
          >
            {label}
          </label>
          {description && <p className="text-sm text-gray-500 dark:text-gray-400">{description}</p>}
        </div>
      </div>

      {hasError && <p className="mt-1.5 text-sm text-red-600 dark:text-red-400">{meta.error}</p>}
    </div>
  );
}
